module.exports = __webpack_public_path__ + "static/media/halloween4.fd2c6626.jpg";